module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "twostepvalidation"
    },
    slot: "twostepvalidation"
  }, [_c('div', {
    staticClass: "layui-form-item"
  }, [_c('v-button', {
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', [_vm._v("添加新项\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": _vm.saveData
    }
  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
    return _c('fieldset', {
      key: 't_' + index,
      staticClass: "layui-elem-field"
    }, [_c('legend', [_vm._v("\n        第" + _vm._s(_vm.dataList.length - index) + "项\n        "), _c('button', {
      staticClass: "layui-btn layui-btn-danger layui-btn-mini",
      on: {
        "click": function($event) {
          _vm.delItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "layui-icon"
    }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
      staticClass: "layui-field-box"
    }, [_c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("网站名称")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "layui-input",
      attrs: {
        "placeholder": "网站名称"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("绑定密钥")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "layui-input",
      attrs: {
        "placeholder": "双重验证绑定密钥"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "layui-form-item"
    }, [_c('div', {
      staticClass: "layui-input-block"
    }, [_c('v-button', {
      attrs: {
        "id": item.text
      },
      on: {
        "click": function($event) {
          _vm.genCode(item)
        }
      }
    }, [_c('span', [_vm._v("生成验证码\n                "), _c('i', {
      staticClass: "layui-icon"
    }, [_vm._v("ဂ")])])])], 1)]), _vm._v(" "), (item.code) ? _c('div', {
      staticClass: "layui-form-item"
    }, [_c('label', {
      staticClass: "layui-form-label"
    }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
      staticClass: "layui-input-block"
    }, [_c('blockquote', {
      staticClass: "layui-elem-quote"
    }, [_vm._v("\n              " + _vm._s(item.code) + "\n              "), _c('button', {
      staticClass: "layui-btn layui-btn-sm btn-copy",
      attrs: {
        "data-clipboard-text": item.code
      }
    }, [_vm._v("\n                复制\n              ")])])])]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('p', [_vm._v("\n        可用于谷歌验证等支持 TOTP 算法的二步验证 算法，结合\n        thirty-two，jssha生成\n      ")]), _vm._v(" "), _c('p', [_vm._v("参考：https://github.com/wuyanxin/totp.js")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4a605e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/twostepvalidation.vue
// module id = 333
// module chunks = 2